/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useMutation, useQuery } from 'react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type {
  FirmaDocumentoResponse,
  GetBackAttivitaIdDocumentiIdFirmaParams,
  GetBackAttivitaIdDocumentiIdVisualizzaOldParams,
  GetBackAttivitaIdDocumentiIdVisualizzaParams,
  GetBackDocumentiPlaceholdersParams,
  Placeholders,
  PutBackDocumentiEstraiPdfDaFileFirmato200,
  PutBackDocumentiEstraiPdfDaFileFirmatoBody,
  PutBackDocumentiValidaFirmaBody,
} from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

export const putBackDocumentiValidaFirma = (
  putBackDocumentiValidaFirmaBody: PutBackDocumentiValidaFirmaBody,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  const formData = new FormData();
  formData.append('file', putBackDocumentiValidaFirmaBody.file);

  return apiClientRequest<FirmaDocumentoResponse[]>(
    {
      url: `/framework-bo-procedimenti/documenti/validaFirma`,
      method: 'put',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    },
    options,
  );
};

export const getPutBackDocumentiValidaFirmaMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackDocumentiValidaFirma>>,
    TError,
    { data: PutBackDocumentiValidaFirmaBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBackDocumentiValidaFirma>>,
  TError,
  { data: PutBackDocumentiValidaFirmaBody },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBackDocumentiValidaFirma>>,
    { data: PutBackDocumentiValidaFirmaBody }
  > = props => {
    const { data } = props ?? {};

    return putBackDocumentiValidaFirma(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutBackDocumentiValidaFirmaMutationResult = NonNullable<
  Awaited<ReturnType<typeof putBackDocumentiValidaFirma>>
>;
export type PutBackDocumentiValidaFirmaMutationBody =
  PutBackDocumentiValidaFirmaBody;
export type PutBackDocumentiValidaFirmaMutationError = ErrorType<unknown>;

export const usePutBackDocumentiValidaFirma = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackDocumentiValidaFirma>>,
    TError,
    { data: PutBackDocumentiValidaFirmaBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutBackDocumentiValidaFirmaMutationOptions(options);

  return useMutation(mutationOptions);
};
export const putBackDocumentiEstraiPdfDaFileFirmato = (
  putBackDocumentiEstraiPdfDaFileFirmatoBody: PutBackDocumentiEstraiPdfDaFileFirmatoBody,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  const formData = new FormData();
  formData.append('file', putBackDocumentiEstraiPdfDaFileFirmatoBody.file);

  return apiClientRequest<PutBackDocumentiEstraiPdfDaFileFirmato200>(
    {
      url: `/framework-bo-procedimenti/documenti/estraiPdfDaFileFirmato`,
      method: 'put',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    },
    options,
  );
};

export const getPutBackDocumentiEstraiPdfDaFileFirmatoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackDocumentiEstraiPdfDaFileFirmato>>,
    TError,
    { data: PutBackDocumentiEstraiPdfDaFileFirmatoBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putBackDocumentiEstraiPdfDaFileFirmato>>,
  TError,
  { data: PutBackDocumentiEstraiPdfDaFileFirmatoBody },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putBackDocumentiEstraiPdfDaFileFirmato>>,
    { data: PutBackDocumentiEstraiPdfDaFileFirmatoBody }
  > = props => {
    const { data } = props ?? {};

    return putBackDocumentiEstraiPdfDaFileFirmato(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutBackDocumentiEstraiPdfDaFileFirmatoMutationResult = NonNullable<
  Awaited<ReturnType<typeof putBackDocumentiEstraiPdfDaFileFirmato>>
>;
export type PutBackDocumentiEstraiPdfDaFileFirmatoMutationBody =
  PutBackDocumentiEstraiPdfDaFileFirmatoBody;
export type PutBackDocumentiEstraiPdfDaFileFirmatoMutationError =
  ErrorType<unknown>;

export const usePutBackDocumentiEstraiPdfDaFileFirmato = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putBackDocumentiEstraiPdfDaFileFirmato>>,
    TError,
    { data: PutBackDocumentiEstraiPdfDaFileFirmatoBody },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions =
    getPutBackDocumentiEstraiPdfDaFileFirmatoMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getBackDocumentiPlaceholders = (
  params?: GetBackDocumentiPlaceholdersParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Placeholders>(
    {
      url: `/framework-bo-procedimenti/documenti/placeholders`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackDocumentiPlaceholdersQueryKey = (
  params?: GetBackDocumentiPlaceholdersParams,
) =>
  [
    `/framework-bo-procedimenti/documenti/placeholders`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackDocumentiPlaceholdersQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackDocumentiPlaceholders>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackDocumentiPlaceholdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackDocumentiPlaceholders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackDocumentiPlaceholders>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetBackDocumentiPlaceholdersQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackDocumentiPlaceholders>>
  > = ({ signal }) =>
    getBackDocumentiPlaceholders(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackDocumentiPlaceholdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackDocumentiPlaceholders>>
>;
export type GetBackDocumentiPlaceholdersQueryError = ErrorType<unknown>;

export const useGetBackDocumentiPlaceholders = <
  TData = Awaited<ReturnType<typeof getBackDocumentiPlaceholders>>,
  TError = ErrorType<unknown>,
>(
  params?: GetBackDocumentiPlaceholdersParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackDocumentiPlaceholders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackDocumentiPlaceholdersQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * produzione del Documento in modo da consentire la verifica di completezza di sezioni dati e sezioni documento
 * @summary Visualizza Documento
 */
export const getBackAttivitaIdDocumentiIdVisualizza = (
  idTaskInstance: string,
  idDocumento: string,
  params: GetBackAttivitaIdDocumentiIdVisualizzaParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string[]>(
    {
      url: `/framework-bo-procedimenti/attivita/${idTaskInstance}/documenti/${idDocumento}/visualizza`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackAttivitaIdDocumentiIdVisualizzaQueryKey = (
  idTaskInstance: string,
  idDocumento: string,
  params: GetBackAttivitaIdDocumentiIdVisualizzaParams,
) =>
  [
    `/framework-bo-procedimenti/attivita/${idTaskInstance}/documenti/${idDocumento}/visualizza`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackAttivitaIdDocumentiIdVisualizzaQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdVisualizza>>,
  TError = ErrorType<unknown>,
>(
  idTaskInstance: string,
  idDocumento: string,
  params: GetBackAttivitaIdDocumentiIdVisualizzaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdVisualizza>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdVisualizza>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackAttivitaIdDocumentiIdVisualizzaQueryKey(
      idTaskInstance,
      idDocumento,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdVisualizza>>
  > = ({ signal }) =>
    getBackAttivitaIdDocumentiIdVisualizza(
      idTaskInstance,
      idDocumento,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idTaskInstance && idDocumento),
    ...queryOptions,
  };
};

export type GetBackAttivitaIdDocumentiIdVisualizzaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdVisualizza>>
>;
export type GetBackAttivitaIdDocumentiIdVisualizzaQueryError =
  ErrorType<unknown>;

/**
 * @summary Visualizza Documento
 */
export const useGetBackAttivitaIdDocumentiIdVisualizza = <
  TData = Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdVisualizza>>,
  TError = ErrorType<unknown>,
>(
  idTaskInstance: string,
  idDocumento: string,
  params: GetBackAttivitaIdDocumentiIdVisualizzaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdVisualizza>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackAttivitaIdDocumentiIdVisualizzaQueryOptions(
    idTaskInstance,
    idDocumento,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * produzione del Documento in modo da consentire la verifica di completezza di sezioni dati e sezioni documento
 * @summary Visualizza Documento
 */
export const getBackAttivitaIdDocumentiIdVisualizzaOld = (
  idTaskInstance: string,
  idDocumento: string,
  params: GetBackAttivitaIdDocumentiIdVisualizzaOldParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string[]>(
    {
      url: `/framework-bo-procedimenti/attivita/${idTaskInstance}/documenti/${idDocumento}/visualizzaOld`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackAttivitaIdDocumentiIdVisualizzaOldQueryKey = (
  idTaskInstance: string,
  idDocumento: string,
  params: GetBackAttivitaIdDocumentiIdVisualizzaOldParams,
) =>
  [
    `/framework-bo-procedimenti/attivita/${idTaskInstance}/documenti/${idDocumento}/visualizzaOld`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackAttivitaIdDocumentiIdVisualizzaOldQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdVisualizzaOld>>,
  TError = ErrorType<unknown>,
>(
  idTaskInstance: string,
  idDocumento: string,
  params: GetBackAttivitaIdDocumentiIdVisualizzaOldParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdVisualizzaOld>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdVisualizzaOld>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackAttivitaIdDocumentiIdVisualizzaOldQueryKey(
      idTaskInstance,
      idDocumento,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdVisualizzaOld>>
  > = ({ signal }) =>
    getBackAttivitaIdDocumentiIdVisualizzaOld(
      idTaskInstance,
      idDocumento,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idTaskInstance && idDocumento),
    ...queryOptions,
  };
};

export type GetBackAttivitaIdDocumentiIdVisualizzaOldQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdVisualizzaOld>>
>;
export type GetBackAttivitaIdDocumentiIdVisualizzaOldQueryError =
  ErrorType<unknown>;

/**
 * @summary Visualizza Documento
 */
export const useGetBackAttivitaIdDocumentiIdVisualizzaOld = <
  TData = Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdVisualizzaOld>>,
  TError = ErrorType<unknown>,
>(
  idTaskInstance: string,
  idDocumento: string,
  params: GetBackAttivitaIdDocumentiIdVisualizzaOldParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdVisualizzaOld>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackAttivitaIdDocumentiIdVisualizzaOldQueryOptions(
    idTaskInstance,
    idDocumento,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Recupero di un documento per firmarlo o per visualizzarlo firmato
 * @summary Recupera documento per firma
 */
export const getBackAttivitaIdDocumentiIdFirma = (
  idTaskInstance: string,
  idDocumento: string,
  params: GetBackAttivitaIdDocumentiIdFirmaParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<string[]>(
    {
      url: `/framework-bo-procedimenti/attivita/${idTaskInstance}/documenti/${idDocumento}/firma`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetBackAttivitaIdDocumentiIdFirmaQueryKey = (
  idTaskInstance: string,
  idDocumento: string,
  params: GetBackAttivitaIdDocumentiIdFirmaParams,
) =>
  [
    `/framework-bo-procedimenti/attivita/${idTaskInstance}/documenti/${idDocumento}/firma`,
    ...(params ? [params] : []),
  ] as const;

export const getGetBackAttivitaIdDocumentiIdFirmaQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdFirma>>,
  TError = ErrorType<unknown>,
>(
  idTaskInstance: string,
  idDocumento: string,
  params: GetBackAttivitaIdDocumentiIdFirmaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdFirma>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdFirma>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackAttivitaIdDocumentiIdFirmaQueryKey(
      idTaskInstance,
      idDocumento,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdFirma>>
  > = ({ signal }) =>
    getBackAttivitaIdDocumentiIdFirma(
      idTaskInstance,
      idDocumento,
      params,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(idTaskInstance && idDocumento),
    ...queryOptions,
  };
};

export type GetBackAttivitaIdDocumentiIdFirmaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdFirma>>
>;
export type GetBackAttivitaIdDocumentiIdFirmaQueryError = ErrorType<unknown>;

/**
 * @summary Recupera documento per firma
 */
export const useGetBackAttivitaIdDocumentiIdFirma = <
  TData = Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdFirma>>,
  TError = ErrorType<unknown>,
>(
  idTaskInstance: string,
  idDocumento: string,
  params: GetBackAttivitaIdDocumentiIdFirmaParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackAttivitaIdDocumentiIdFirma>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackAttivitaIdDocumentiIdFirmaQueryOptions(
    idTaskInstance,
    idDocumento,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
